import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ErrorHandler } from '../../../../shared/ErrorHandler';
import { UserService } from '../../../../shared/user.service';
import swal from 'sweetalert2';
import { NgForm } from '@angular/forms';

@Component({
  selector: 'app-vleform',
  templateUrl: './vleform.component.html',
  styleUrls: ['./vleform.component.css']
})
export class VleformComponent implements OnInit {
  title="Add VLE";
  data : any = {};
  formInvalid : boolean = false;
  d : any = {};
  fileToUpload: File = null;

  VL_Id : number;
  mode : string;
  ActiveDetailsList: any=[];
  ActiveDetails: any=[];
  ActiveDetail: any=[];
  ActiveDetai: any=[];
  Active: any=[];
  ActiveDistrict: any=[];
  photoImageUrl: any;
  AS_Photo: string;
  Activespili: any=[];
  constructor(public service : UserService,private router: Router,private route: ActivatedRoute,  private errorHandler: ErrorHandler) { }

  ngOnInit() {
   
    this.GetAllQualification();
    this.GetState();
    this.GetsDistrict();
   
    this.route.params.subscribe(params => {      
      this.VL_Id = params['VL_Id'];  
      this.mode  =   params['mode'];   
        
        if(this.VL_Id > 0){
          this.getbyid(this.VL_Id)
        }    
        
    });

    if(this.mode=='view'){
      this.title = "View VLE";
    }
    else if(this.mode=='edit'){
      this.title = "Edit VLE";
    } 
   
  }
  SaveDistrict(Distict: NgForm){
        
    if(Distict.invalid)
    {
      this.formInvalid = true;
      swal('Warning!', 'Please fill all the mandatory fields.', 'warning');
      return;
    }     

    else{                                     
            this.data = this.service.PostVLE(Distict.value);    
            this.data.subscribe(
            (response) => {
              Distict.reset();
              Distict.resetForm();
              Distict.form.markAsPristine();
              Distict.form.markAsUntouched();        
              swal('Success!', 'Assistant Added Successfully .', 'success');
              this.router.navigate(['/home/VLE']) ;   
              document.getElementById('loader-spinner').style.display = "none";           
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
              if (error.status == 401) {
                this.errorHandler.HandlerError(error);
              }
              else if (error.status == 400) {
                swal('Warning!', error.error.Message, 'warning');
              }
            });    
    
    
    } 
  }
  cancel(){
    this.d.district_name="";
  }
  
  UpdateDistrict(District: NgForm) {  
    this.data = this.service.updateVLE(District.value,this.VL_Id);
   this.data.subscribe(
     (response) => {
      District.reset();
      District.resetForm();
      District.form.markAsPristine();
      District.form.markAsUntouched();           
                   
       swal('Success!', 'Assistances updated Successfully .', 'success');
       document.getElementById('loader-spinner').style.display = "none";   
       this.router.navigate(['/home/VLE']) ;           
     }, (error) => {
       document.getElementById('loader-spinner').style.display = "none";
       if (error.status == 401) {
         this.errorHandler.HandlerError(error);
       }
       else if (error.status == 400) {
        swal('Warning!', error.error.Message, 'warning');
       }
     });   
}

Cancel(){
//this.router.navigate(['/menu/master']) ; 
this.d.district_name='';
this.d.district_id='';
}

    GetAllQualification(){
      //alert('Inside');
      
      
        document.getElementById('loader-spinner').style.display = "block";
        this.data = this.service.GetallCategoryDrop();
        this.data.subscribe(
          (response: any) => {
            this.ActiveDetail = response;
          document.getElementById('loader-spinner').style.display = "none";
          }, (error) => {
            document.getElementById('loader-spinner').style.display = "none";
          });
      }
      GetState(){
        //alert('Inside');
        
        
          document.getElementById('loader-spinner').style.display = "block";
          this.data = this.service.GetallCategory();
          this.data.subscribe(
            (response: any) => {
              this.Active = response;
            document.getElementById('loader-spinner').style.display = "none";
            }, (error) => {
              document.getElementById('loader-spinner').style.display = "none";
            });
        }
        GetsDistrict(){
          //alert('Inside');
          
          
            document.getElementById('loader-spinner').style.display = "block";
            this.data = this.service.GetallCategorydrop();
            this.data.subscribe(
              (response: any) => {
                this.ActiveDistrict = response;
              document.getElementById('loader-spinner').style.display = "none";
              }, (error) => {
                document.getElementById('loader-spinner').style.display = "none";
              });
          }
         
          FileInputPhoto(file: FileList) {
    
            //let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.pdef|.pdf|.PDF)$/;
            let regex = /^([a-zA-Z0-9\s_\\.\-:])+(.jpg|.jpeg|.png|JPEG|JPG)$/;
            let s: any = file.item(0).size / 1024;
            let size: any = parseFloat(s).toFixed(2);
            let uploadedFilename = file.item(0).name;
            if (uploadedFilename.match(regex) && (size <= 5048)) {
              this.fileToUpload = file.item(0);
              var reader = new FileReader();
              reader.onload = (event: any) => {
                 this.photoImageUrl = event.target.result;
              }
              reader.readAsDataURL(this.fileToUpload);
              const data = new FormData();
              data.append("UploadedImage", file.item(0));
              let x = this.service.uploadImagesFile(data);
              x.subscribe(
                (response) => {
                  
        
                }, (error) => {
                  let i: any = document.getElementById('VL_Photo');
                  i.value = "";
                  if (error.status == 400) {
                     this.AS_Photo = "assets/images/image-default.png";
                    swal('Warning!', error.error.Message, 'warning');
                  }
                });
            }
            else {
              let i: any = document.getElementById('VL_Photo');
              i.value = "";
              if (!uploadedFilename.match(regex))
                swal('Warning!', "Please upload PDF and Image file with extension pdef or pdf and .jpeg,jpg or png", 'warning');
              else if (size > 2048)
                swal('Warning!', "Please upload image file less than 2mb", 'warning');
            }
          }
          
        
          getImagePDFUrl() {
            let imagename = null;
            try {
              imagename = document.getElementById('VL_Photo');
              return imagename.files[0].name;
            }
            catch (e) {
              return null;
            }
          }
          getbyid(VL_Id) {
            {
              
             // this.a.Image_path=this.photoImageUrl;
              document.getElementById('loader-spinner').style.display = "block";
              this.data = this.service.getbyVLE(VL_Id);
              this.data.subscribe(
                (response: any) => {
                this.d = response;
                this.photoImageUrl=this.d.VLPhoto;
                  if (this.d.VL_DOB != null)
                  this.d.VL_DOB = ((this.d.VL_DOB).split('T'))[0];
           document.getElementById('loader-spinner').style.display = "none";
                }, (error) => {
                  document.getElementById('loader-spinner').style.display = "none";
                });
            }
        
          }
        
}



// WEBPACK FOOTER //
// ./src/app/Pages/manage/vle/vleform/vleform.component.ts